import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
// material
import { Box, Grid, Card, Paper, Typography, CardContent } from '@mui/material';
// utils
import { fNumber } from '../../../common/utils/formatNumber';
import { useTranslation } from '../../../common/LocalizationProvider';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

PhaseItem.propTypes = {
  phase: PropTypes.object
};

function PhaseItem({ phase }) {
  const t = useTranslation();

  const { icon, value, name } = phase;

  return (
    <Grid item xs={12}>
      <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center' }}>
        <Box sx={{ mb: 0.5 }}>{icon}</Box>
        <Typography variant="h6">{fNumber(value)}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t(name)}
        </Typography>
      </Paper>
    </Grid>
  );
}

AppPhasesSummary.propTypes = {
  summary: PropTypes.array
};

export default function AppPhasesSummary({ summary }) {
  const PHASES = [
    {
      name: 'DB_Landing_S',
      value: summary.reduce((sum, item) => {
        sum += item.atterrissages;
        return sum;
      }, 0),
      icon: <Icon icon="fa-regular:paper-plane" rotate={1} width={24} height={24} />
    },
    {
      name: 'DB_Touché',
      value: summary.reduce((sum, item) => {
        sum += item.touchers;
        return sum;
      }, 0),
      icon: <Icon icon="fa-regular:paper-plane" rotate={1} width={24} height={24} />
    },
    {
      name: 'DB_TakeOff_S',
      value: summary.reduce((sum, item) => {
        sum += item.decollage;
        return sum;
      }, 0),
      icon: <Icon icon="fa-regular:paper-plane" width={24} height={24} />
    },
    {
      name: 'Total_Point',
      value: summary.reduce((sum, item) => {
        sum += item.totalPoint;
        return sum;
      }, 0),
      icon: <Icon icon="healthicons:award-trophy" width={24} height={24} />
    }
  ];

  return (
    <Card
      sx={{
        '& .MuiTimelineItem-missingOppositeContent:before': {
          display: 'none'
        },
        height: 600
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          {PHASES.map((item) => (
            <PhaseItem key={item.name} phase={item} />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
